/**
 * @deprecated
 *
 * DO NOT ADD NEW ICONS TO THIS FILE
 *
 * Any icons belonging to the Futuro design system should be added to the new
 * foundations directory, and follow naming conventions found in the CORE figma
 * shared/foundations/Icons/svg.tsx
 */
import * as React from 'react';

export default [
  'ascending',
  'standing-orders',
  'descending',
  'filter',
  'trash',
  'increment',
  'products',
  'orders',
  'home',
  'cart',
  'refresh',
  'history',
  'help',
  'settings',
  'decrement',
  'chevron-down',
  'sort',
  'logout',
  'label',
  'dollar',
  'notifications',
  'store',
  'favourite',
  'clock',
  'shuffle',
  'padlock',
  'star',
  'hourglass',
  'payment',
  'back',
  'standing-orders-nav',
  'search',
  'cancel',
  'like',
  'trending',
  'download',
  'edit',
  'cloud',
  'exo',
  'desktop',
  'circle-arrow-right',
  'right-open-big',
  'tooltip',
  'menu',
  'logout-1',
  'trading-details',
  'dashboard',
  'trading',
  'orders-1',
  'clock-1',
  'calendar',
  'schedules',
  'customers',
  'product',
  'visibility-groups',
  'pricing-groups',
  'search-1',
  'reports',
  'cancel-1',
  'settings-1',
  'clock-2',
  'cross',
  'caret-down',
  'dollar-1',
  'documents',
  'add',
  'products-1',
  'info',
  'freight-groups',
  'customer',
  'remove',
  'return',
  'refresh-1',
  'plus',
  'cancel-2',
  'circle-arrow-left',
  'gauge',
  'exclamation-mark',
  'star-outline',
  'help-circled',
  'sync',
  'user-circle',
  'folder',
  'growthEngineConfetti',
  'refresh-2',
  'camera',
  'gallery',
  'addComment',
];

/**
 * @deprecated
 *
 * DO NOT ADD NEW ICONS TO THIS OBJECT
 *
 * Any icons belonging to the Futuro design system should be added to the new
 * foundations directory, and follow naming conventions found in the CORE figma
 * shared/foundations/Icons/svg.tsx
 */
export const SVGIcons = {
  addComment: (
    <g className="svg-fill">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14 16H11.5C11.185 16 10.889 16.148 10.7 16.4L8.5 19.333L6.3 16.4C6.111 16.148 5.815 16 5.5 16H5C4.449 16 4 15.551 4 15V5C4 4.449 4.449 4 5 4H19C19.551 4 20 4.449 20 5V14C20 15.5 22 15.654 22 14V5C22 3.346 20.654 2 19 2H5C3.346 2 2 3.346 2 5V15C2 16.654 3.346 18 5 18L6.35 19.8L7.7 21.6C7.889 21.852 8.185 22 8.5 22C8.815 22 9.111 21.852 9.3 21.6L12 18H14C15.5 18 15.5 16 14 16ZM17 7H7C6.448 7 6 7.448 6 8C6 8.552 6.448 9 7 9H17C17.552 9 18 8.552 18 8C18 7.448 17.552 7 17 7ZM7 11H17C17.552 11 18 11.448 18 12C18 12.552 17.552 13 17 13H7C6.448 13 6 12.552 6 12C6 11.448 6.448 11 7 11Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19 16C19.5523 16 20 16.4477 20 17V18H21C21.5523 18 22 18.4477 22 19C22 19.5523 21.5523 20 21 20H20V21C20 21.5523 19.5523 22 19 22C18.4477 22 18 21.5523 18 21V20H17C16.4477 20 16 19.5523 16 19C16 18.4477 16.4477 18 17 18H18V17C18 16.4477 18.4477 16 19 16Z"
      />
    </g>
  ),
  gallery: (
    <g
      style={{ transform: 'scale(0.6) translate(0px, 2px)' }}
      className="svg-fill"
    >
      <path d="M40.7192 0H11.1735C10.8221 0 10.4851 0.13959 10.2366 0.388061C9.98817 0.636532 9.84858 0.97353 9.84858 1.32492V4.90221H6.27129C5.9199 4.90221 5.5829 5.0418 5.33443 5.29027C5.08596 5.53874 4.94637 5.87574 4.94637 6.22713V9.80442H1.32492C0.97353 9.80442 0.636531 9.94401 0.38806 10.1925C0.139589 10.4409 0 10.7779 0 11.1293V34.5363C0 34.8877 0.139589 35.2247 0.38806 35.4731C0.636531 35.7216 0.97353 35.8612 1.32492 35.8612H30.8707C31.2221 35.8612 31.559 35.7216 31.8075 35.4731C32.056 35.2247 32.1956 34.8877 32.1956 34.5363V30.9148H35.7729C36.1243 30.9148 36.4613 30.7752 36.7097 30.5268C36.9582 30.2783 37.0978 29.9413 37.0978 29.5899V26.0126H40.6751C41.0265 26.0126 41.3635 25.873 41.6119 25.6246C41.8604 25.3761 42 25.0391 42 24.6877V1.32492C42.0002 0.98105 41.8667 0.650575 41.6277 0.403336C41.3887 0.156096 41.0629 0.0114623 40.7192 0ZM29.5457 33.2114H2.64984V28.8391L10.5552 23.0978L18.1514 29.7224C18.3624 29.9041 18.6254 30.0148 18.9029 30.0385C19.1804 30.0623 19.4583 29.9981 19.6972 29.8549L29.5457 24.0694V33.2114ZM14.8391 18.4164C14.8391 17.5953 15.0826 16.7927 15.5388 16.11C15.9949 15.4273 16.6433 14.8952 17.4019 14.581C18.1604 14.2668 18.9951 14.1846 19.8004 14.3448C20.6057 14.5049 21.3454 14.9003 21.926 15.4809C22.5066 16.0615 22.902 16.8012 23.0622 17.6065C23.2224 18.4118 23.1402 19.2465 22.8259 20.0051C22.5117 20.7637 21.9796 21.412 21.2969 21.8682C20.6142 22.3243 19.8116 22.5678 18.9905 22.5678C17.8895 22.5678 16.8336 22.1304 16.055 21.3519C15.2765 20.5734 14.8391 19.5174 14.8391 18.4164ZM34.4479 28.265H32.1956V11.1735C32.1956 10.8221 32.056 10.4851 31.8075 10.2366C31.559 9.98817 31.2221 9.84858 30.8707 9.84858H7.59621V7.59621H34.4479V28.265ZM39.3943 23.3628H37.0978V6.27129C37.0978 5.9199 36.9582 5.5829 36.7097 5.33443C36.4613 5.08596 36.1243 4.94637 35.7729 4.94637H12.4984V2.64984H39.3943V23.3628Z" />
    </g>
  ),
  camera: (
    <g
      style={{ transform: 'scale(0.7) translate(0px, 2px)' }}
      className="svg-fill"
    >
      <path d="M28.2336 4.25939H24.5294L23.7023 2.00227C23.4865 1.4562 23.1268 0.982935 22.5514 0.58248C22.012 0.182025 21.4366 0 20.8612 0H12.4098C11.8344 0 11.259 0.182025 10.7195 0.58248C10.1801 0.982935 9.7845 1.4562 9.56872 2.00227L8.7056 4.25939H5.0014C3.85057 4.25939 2.8436 4.65984 2.01645 5.49716C1.1893 6.33447 0.793701 7.31741 0.793701 8.51877V23.4084C0.793701 24.5734 1.1893 25.5927 2.01645 26.43C2.8436 27.2673 3.85057 27.6678 5.0014 27.6678H28.1977C29.3485 27.6678 30.3554 27.2673 31.1826 26.43C32.0098 25.5927 32.4053 24.6098 32.4053 23.4084V8.51877C32.4053 7.35381 32.0098 6.33447 31.1826 5.49716C30.3914 4.65984 29.3844 4.25939 28.2336 4.25939ZM21.8322 21.2241C20.3936 22.6803 18.6314 23.4084 16.6175 23.4084C14.5676 23.4084 12.8414 22.6803 11.4028 21.2241C9.96432 19.7679 9.24505 18.0205 9.24505 15.9454C9.24505 13.9067 9.96432 12.1229 11.4028 10.6667C12.8414 9.21046 14.6036 8.48236 16.6175 8.48236C18.6674 8.48236 20.3936 9.21046 21.8322 10.6667C23.2707 12.1229 23.99 13.8703 23.99 15.9454C23.99 18.0205 23.2707 19.7679 21.8322 21.2241Z" />
      <path d="M16.6175 11.1763C15.3228 11.1763 14.208 11.6496 13.2729 12.5961C12.3379 13.5427 11.8704 14.6712 11.8704 15.9818C11.8704 17.2924 12.3379 18.4209 13.2729 19.3675C14.208 20.314 15.3228 20.7873 16.6175 20.7873C17.9122 20.7873 19.027 20.314 19.9621 19.3675C20.8971 18.4209 21.3646 17.2924 21.3646 15.9818C21.3646 14.6712 20.8971 13.5427 19.9621 12.5961C19.027 11.6496 17.9122 11.1763 16.6175 11.1763Z" />
    </g>
  ),
  'refresh-2': (
    <path
      className="svg-fill"
      d="M1.30845 15.1249C1.79135 15.0246 2.09963 14.5533 1.99984 14.0725C0.984737 9.20338 3.60417 4.33904 8.22826 2.5049C12.2025 0.928362 16.63 2.00036 19.4479 5.02106L17.7841 4.77413C17.2983 4.7029 16.8445 5.03767 16.7726 5.525C16.7007 6.01114 17.0369 6.46403 17.5234 6.53586L21.3504 7.10272C21.3931 7.10925 21.4371 7.11281 21.4804 7.11281C21.6705 7.11281 21.8576 7.05167 22.012 6.93711C22.2009 6.79703 22.3274 6.58631 22.3625 6.35304L22.9285 2.52983C23.0016 2.04369 22.6654 1.59079 22.1778 1.51837C21.6949 1.44655 21.2381 1.78192 21.1662 2.26924L20.9132 3.97458C17.6113 0.294424 12.313 -1.03043 7.57192 0.850602C2.14002 3.0029 -0.937367 8.71665 0.255335 14.4351C0.342055 14.8554 0.71329 15.1439 1.1267 15.1439C1.18669 15.1439 1.24787 15.1379 1.30845 15.1249ZM23.7447 9.56249C23.6449 9.0811 23.1703 8.77482 22.6904 8.87276C22.2086 8.97307 21.8992 9.44496 22.0002 9.92576C23.0165 14.796 20.3958 19.6616 15.7694 21.4951C11.798 23.0699 7.37115 21.9985 4.55215 18.979L6.20875 19.2241C6.69343 19.293 7.14722 18.9606 7.22028 18.4738C7.29215 17.9877 6.95597 17.5348 6.4695 17.4624L2.64133 16.8955C2.40909 16.8629 2.17031 16.921 1.98024 17.0611C1.79017 17.2018 1.66484 17.4125 1.62979 17.6458L1.06373 21.4702C0.991864 21.9563 1.32805 22.4092 1.81452 22.481C1.85847 22.4876 1.90243 22.4911 1.94698 22.4911C2.38058 22.4911 2.76132 22.173 2.82606 21.7314L3.08147 20.013C5.37362 22.5736 8.62801 24 11.9947 24C13.4748 24 14.977 23.7246 16.4275 23.15C21.86 20.9977 24.9374 15.2828 23.7447 9.56249Z"
    />
  ),
  chevronRight: (
    <path
      style={{ transform: 'translate(5px, 5px)' }}
      className="svg-fill"
      d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"
    />
  ),
  tick: (
    <path
      style={{ transform: 'scale(1.5)' }}
      className="svg-fill"
      fill="#20C43C"
      d="M6.18 12.0003C5.92 12.0003 5.66 11.9203 5.44 11.7603L1.48 8.80028C0.939998 8.40028 0.839998 7.65028 1.25 7.12028C1.66 6.59028 2.42 6.49028 2.96 6.89028L5.9 9.08028L11.78 0.530277C12.16 -0.0197227 12.92 -0.159723 13.47 0.210277C14.03 0.580277 14.17 1.33028 13.8 1.88028L7.2 11.4803C7 11.7503 6.71 11.9303 6.38 11.9803C6.31 11.9903 6.25 12.0003 6.18 12.0003Z"
    />
  ),
  greenTick: (
    <g
      className="svg-fill"
      style={{ transform: 'scale(1) translate(1px, 1px)' }}
    >
      <circle cx="11" cy="11" r="11" fill="#20C43C" />
      <path
        style={{ transform: 'scale(0.6) translate(7px, 7px)' }}
        d="M8.82599 20.0585C8.39776 20.0585 7.96952 19.9268 7.60717 19.6632L1.08482 14.7879C0.195406 14.1291 0.0307001 12.8938 0.705994 12.0209C1.38129 11.1479 2.63305 10.9832 3.52246 11.6421L8.36482 15.2491L18.0495 1.16677C18.6754 0.260886 19.9272 0.0302982 20.8331 0.63971C21.7554 1.24912 21.986 2.48442 21.3766 3.3903L10.506 19.2021C10.1766 19.6468 9.69894 19.9432 9.15541 20.0256C9.04011 20.0421 8.94129 20.0585 8.82599 20.0585Z"
        fill="white"
      />
    </g>
  ),
  mailbox: (
    <path
      className="svg-fill"
      fillRule="nonzero"
      d="M85.06 15.933C85.06 7.133 78.734 0 70.933 0H29.288C19.055 0 10.76 9.356 10.76 20.897v21.488L3.09 54.79c-5.816 9.601-3.227 20.716 6.12 24.135 14.338 4.535 23.444-3.702 27.971-11.174l4.943-7.987V100h11.127V46.632L85.06 36.83V15.933zm-70.59 4.964c0-9.478 6.814-17.188 15.192-17.188 8.377 0 15.193 7.711 15.193 17.188l-.019 23.465-30.368-3.957V20.897h.001zm19.558 44.904l-.009.015-.009.015c-3.98 6.573-12.825 13.26-23.538 9.608-9.826-4.184-6.905-14.198-4.216-18.712l7.81-12.63 30.817 4.167-10.855 17.537zm28.97-54.853l-4.112.419c-2.424.182-2.473 2.874-2.473 3.52 0 2.254.072 22.525 0 23.051-.145 1.071-.936 2.075-2.076 2.128-1.604.076-2.6-1.54-2.6-2.977 0-1.188-.076-24.812 0-27.918 0-1.042.715-2.174 1.826-2.271l9.434-.829v4.877zm-7.286 25.575c0 .809-.568 1.465-1.27 1.465-.702 0-1.27-.656-1.27-1.465 0-.81.568-1.465 1.27-1.465.702 0 1.27.656 1.27 1.465z"
    />
  ),
  calendar: (
    <path
      className="svg-fill"
      fillRule="nonzero"
      d="M17 6.375c.518 0 .938-.42.938-.938v-2.5a.937.937 0 1 0-1.875 0v2.5c0 .518.42.938.937.938zm4.063-2.348h-1.875v1.41a2.187 2.187 0 1 1-4.375 0v-1.41H9.186v1.41a2.187 2.187 0 1 1-4.374 0v-1.41H2.938A.937.937 0 0 0 2 4.964v16.098c0 .518.42.938.938.938h18.125c.517 0 .937-.42.937-.938V4.965a.937.937 0 0 0-.938-.937zM20 20H4V8h16v12zM7 10v2h2v-2H7zm0 3v2h2v-2H7zm0 3v2h2v-2H7zm4-6v2h2v-2h-2zm0 3v2h2v-2h-2zm0 3v2h2v-2h-2zm4-6v2h2v-2h-2zm0 3v2h2v-2h-2zm0 3v2h2v-2h-2zM7 6.375c.518 0 .938-.42.938-.938v-2.5a.937.937 0 1 0-1.875 0v2.5c0 .518.42.938.937.938z"
    />
  ),
  creditCard: (
    <path
      className="svg-fill"
      fillRule="nonzero"
      d="M0 18.846V9h24v9.846C24 20.03 23.127 21 22.038 21H1.962C.872 21 0 20.03 0 18.846zm2 0c0 .09.056.154.114.154h19.772c.058 0 .114-.063.114-.154V11H2v7.846zM4 12h9v2H4v-2zm0 3h9v2H4v-2zM22.038 2C23.1 2 24 2.867 24 4v4H0V4c0-1.133.9-2 1.962-2h20.076zM22 6V4c0 .028-.029 0-.114 0H2.114C2.029 4 2 4.028 2 4v2h20z"
    />
  ),
  pencil: (
    <path
      style={{ transform: 'translate(0px, -1px) scale(0.8)' }}
      className="svg-fill"
      fillRule="nonzero"
      d="M1.2632 30.8988C1.47987 31.0821 1.67987 31.2654 3.07987 31.1488C4.21321 31.0654 6.14653 30.7821 9.52987 30.1488C10.3465 30.0821 11.1132 29.6988 11.6465 29.0821L27.7132 10.3654C28.3799 9.59878 28.6965 8.61545 28.6132 7.59878C28.5299 6.58211 28.0632 5.66544 27.2965 4.99878L22.9299 1.24878C21.3299 -0.117889 18.9299 0.0654445 17.5632 1.66544L14.9132 4.76545L1.49653 20.3988C0.9632 21.0321 0.696538 21.8321 0.746538 22.5488C0.496538 30.2321 0.879868 30.5821 1.2632 30.8988ZM9.26321 28.1988C6.81321 28.6654 3.96321 29.1154 2.71321 29.2154C2.61321 27.9821 2.62987 25.0654 2.71321 22.4821C2.71321 22.4321 2.72986 22.3821 2.72986 22.3321L9.5132 28.1321C9.42986 28.1488 9.36321 28.1821 9.26321 28.1988ZM19.0632 2.93211C19.3965 2.54878 19.8465 2.33211 20.3132 2.29878C20.7799 2.26545 21.2632 2.39878 21.6465 2.73211L26.0132 6.48211C26.3799 6.79878 26.6132 7.24878 26.6465 7.73211C26.6799 8.21544 26.5299 8.69878 26.2132 9.06544L24.1965 11.4154L17.0465 5.28211L19.0632 2.93211ZM15.7632 6.78211L22.9132 12.9154L10.9965 26.7988L3.82987 20.6821L15.7632 6.78211Z"
      fill="white"
    />
  ),
  phone: (
    <path
      className="svg-fill"
      fillRule="nonzero"
      d="M7.816 11.059l1.71-1.711a.78.78 0 0 0 .195-.794 8.836 8.836 0 0 1-.443-2.776A.78.78 0 0 0 8.5 5H5.778A.78.78 0 0 0 5 5.778C5 13.08 10.919 19 18.222 19a.78.78 0 0 0 .778-.778v-2.714a.78.78 0 0 0-.778-.778 8.872 8.872 0 0 1-2.776-.443.773.773 0 0 0-.794.186l-1.71 1.711a11.782 11.782 0 0 1-5.126-5.125zm4.818 2.604l.604-.604a2.765 2.765 0 0 1 2.835-.671c.68.224 1.41.342 2.15.342A2.78 2.78 0 0 1 21 15.508v2.714A2.78 2.78 0 0 1 18.222 21C9.814 21 3 14.186 3 5.778A2.78 2.78 0 0 1 5.778 3H8.5a2.78 2.78 0 0 1 2.778 2.778c0 .743.116 1.466.351 2.177a2.78 2.78 0 0 1-.688 2.807l-.606.606a9.8 9.8 0 0 0 2.299 2.295z"
    />
  ),
  mail: (
    <g className="svg-fill" fillRule="evenodd">
      <path
        fillRule="nonzero"
        d="M19 7H5.009L5 17h14V7zm.2-2c.99 0 1.8.787 1.8 1.75v10.5c0 .963-.81 1.75-1.8 1.75H4.8c-.99 0-1.8-.787-1.8-1.75l.009-10.5C3.009 5.787 3.81 5 4.8 5h14.4z"
      />
      <path d="M20 8.033l-8 5-8-5V6l8 5 8-5v1.033" />
    </g>
  ),
  pin: (
    <path
      fill="none"
      fillRule="evenodd"
      className="svg-stroke"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5a2.5 2.5 0 0 1 0-5 2.5 2.5 0 0 1 0 5z"
    />
  ),
  cross: (
    <path
      className="svg-fill"
      d="M12 10.13L8.261 6.39a1.324 1.324 0 0 0-1.873-.002c-.52.52-.515 1.355.002 1.873L10.13 12l-3.74 3.739a1.324 1.324 0 0 0-.002 1.873c.52.52 1.355.515 1.873-.002L12 13.87l3.739 3.74a1.324 1.324 0 0 0 1.873.002c.52-.52.515-1.355-.002-1.873L13.87 12l3.74-3.739a1.324 1.324 0 0 0 .002-1.873 1.321 1.321 0 0 0-1.873.002L12 10.13z"
    />
  ),
  circleTick: (
    <path
      className="svg-fill"
      fillRule="nonzero"
      d="M16.375 15.438zm0-6.876zm-.625 0a.935.935 0 0 0-.663.275l-4.337 4.337-2.15-2.15a.937.937 0 1 0-1.326 1.326l2.813 2.813a.935.935 0 0 0 1.326 0l5-5a.937.937 0 0 0-.663-1.6zM12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2zm0 18.125a8.125 8.125 0 1 1 0-16.25 8.125 8.125 0 0 1 0 16.25z"
    />
  ),
  circleClock: (
    <path
      className="svg-fill"
      d="M13,6 C13.552,6 14,6.44792171 14,7.002062 L14,10.995876 L17,10.995876 C17.552,10.995876 18,11.4437977 18,11.997938 C18,12.5520783 17.552,13 17,13 L13,13 C12.448,13 12,12.5520783 12,11.997938 L12,7.002062 C12,6.44792171 12.448,6 13,6 Z M4.84844748,8.49174598 L7.27520532,8.49174598 C7.66434778,8.49174598 7.89645645,8.93693001 7.68059905,9.26929047 L4.28701732,14.4944639 C4.09416386,14.7914047 3.66908331,14.7914047 3.47622985,14.4944639 L0.0826481219,9.26929047 C-0.133209279,8.93693001 0.0988993887,8.49174598 0.488041853,8.49174598 L2.81791217,8.49174598 C3.24689599,6.78082737 4.11507289,5.21201081 5.36427059,3.92973243 C7.20499768,2.04026007 9.65182972,1 12.254573,1 C14.8573163,1 17.3041483,2.04026007 19.1448754,3.92973243 C20.9856025,5.81820455 22,8.33083271 22,11.0025006 C22,13.6741685 20.9865769,16.1857964 19.1458498,18.0752688 C17.246656,20.0247562 14.7511017,21 12.2555474,21 C9.75999314,21 7.26541328,20.0257564 5.36524504,18.0752688 C4.98423694,17.684171 4.98423694,17.052013 5.36524504,16.6609152 C5.74625313,16.2698175 6.36210253,16.2698175 6.74311063,16.6609152 C9.78240538,19.7806952 14.7277151,19.7806952 17.7670098,16.6609152 C19.2393966,15.1495374 20.050135,13.140035 20.050135,11.0025006 C20.050135,8.86496624 19.2393966,6.85546387 17.7670098,5.34408602 C16.294623,3.83270818 14.3369625,3.00050013 12.254573,3.00050013 C10.1721835,3.00050013 8.21452296,3.83270818 6.74213618,5.34408602 C5.86637375,6.24303999 5.22468685,7.31821863 4.84844748,8.49174598 Z"
      fill="none"
    />
  ),
  chat: (
    <path
      className="svg-fill"
      d="M5.7157 14.4L1.46223 17.8028C0.872939 18.2742 0 17.8547 0 17.1V2.7C0 1.20883 1.20883 0 2.7 0H15.3C16.7912 0 18 1.20883 18 2.7V11.7C18 13.1912 16.7912 14.4 15.3 14.4H5.7157ZM1.8 15.2274L4.83777 12.7972C4.99736 12.6696 5.19564 12.6 5.4 12.6H15.3C15.7971 12.6 16.2 12.1971 16.2 11.7V2.7C16.2 2.20294 15.7971 1.8 15.3 1.8H2.7C2.20294 1.8 1.8 2.20294 1.8 2.7V15.2274Z"
      fill="none"
    />
  ),
  search: (
    <path
      className="svg-fill"
      fillRule="nonzero"
      d="M21.45 18.8l-5.494-5.496A7.452 7.452 0 0 0 17 9.5 7.5 7.5 0 1 0 9.5 17c1.39 0 2.688-.385 3.804-1.044L18.8 21.45a1.875 1.875 0 1 0 2.652-2.651zM9.5 15a5.5 5.5 0 1 1 0-11 5.5 5.5 0 0 1 0 11z"
    />
  ),
  profile: (
    <path
      className="svg-fill"
      fillRule="nonzero"
      d="M17.989 21.023c0-2.246-2.187-3.389-4.317-4.307-2.123-.914-2.801-1.684-2.801-3.334 0-.989.648-.667.932-2.48.12-.753.692-.013.802-1.73 0-.684-.313-.854-.313-.854s.159-1.013.221-1.793c.064-.817-.398-2.56-2.301-3.095-.332-.34-.557-.882.467-1.424-2.24-.104-2.761 1.068-3.954 1.93-1.015.756-1.289 1.953-1.24 2.59.065.78.223 1.793.223 1.793s-.314.17-.314.854c.11 1.718.684.977.803 1.73.284 1.813.933 1.491.933 2.48 0 1.65-.212 2.21-2.336 3.124-2.131.917-2.794 2.387-2.783 4.516.003.637-.011.871-.011.871h16s-.011-.234-.011-.87zm2.539-5.764c-1.135-.457-1.605-1.002-1.605-2.066 0-.64.418-.432.602-1.603.077-.484.447-.008.518-1.115 0-.44-.202-.55-.202-.55s.103-.657.143-1.16c.05-.627-.364-2.247-2.268-2.247-1.903 0-2.318 1.62-2.269 2.247.042.502.144 1.16.144 1.16s-.202.108-.202.55c.071 1.107.441.631.518 1.115.184 1.172.602.963.602 1.603 0 1.064-.438 1.562-1.809 2.152-.069.03-.12.068-.183.102 1.64.712 4.226 1.941 4.838 4.447H22v-2.318c0-1-.273-1.834-1.472-2.317z"
    />
  ),
  file: (
    <g fill="none" fillRule="evenodd">
      <path
        className="svg-stroke"
        strokeWidth="2"
        d="M13.586 3H6a.998.998 0 0 0-.99 1L5 20c0 .551.446 1 .99 1H18c.548 0 1-.452 1-1V8.414L13.586 3z"
      />
      <path
        className="svg-fill"
        fillRule="nonzero"
        d="M8 15h8v2H8zM8 11h8v2H8zM8 7h8v2H8z"
      />
      <path
        className="svg-stroke"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M13 9V3l6 6z"
      />
    </g>
  ),
  drawers: (
    <path
      className="svg-fill"
      fillRule="nonzero"
      d="M15.781 4H7.818s-.996 0-.996 1h9.955c0-1-.996-1-.996-1zm2.987 3c0-1-.995-1-.995-1H5.827s-.995 0-.995 1v1h13.936V7zm1.99 1l-.588-.592V9H3.43V7.408L2.841 8c-.589.592-1.01.75-.774 2 .236 1.246 1.38 8.076 1.55 9 .185 1.014 1.216 1 1.216 1H18.77s1.03.014 1.217-1c.17-.924 1.312-7.754 1.55-9 .234-1.25-.188-1.408-.778-2zM15.8 13.997c0 .554-.449 1.003-1.003 1.003H8.803A1.003 1.003 0 0 1 7.8 13.997V12h1v2h6v-2h1v1.997z"
    />
  ),
  coupon: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.83419 2C9.46529 2 10.0705 2.25071 10.5168 2.69696L17.303 9.48319C18.2323 10.4125 18.2323 11.9191 17.303 12.8484L12.8484 17.303C11.9191 18.2323 10.4125 18.2323 9.48319 17.303L2.69696 10.5168C2.25071 10.0705 2 9.46529 2 8.83419L2 4.37959C2 3.06538 3.06538 2 4.37959 2L8.83419 2ZM8.83419 4L4.37959 4C4.16995 4 4 4.16995 4 4.37959L4 8.83419C4 8.93486 4.03999 9.03141 4.11118 9.10259L10.8974 15.8888C11.0456 16.0371 11.286 16.0371 11.4342 15.8888L15.8888 11.4342C16.0371 11.286 16.0371 11.0456 15.8888 10.8974L9.10259 4.11118C9.03141 4.03999 8.93486 4 8.83419 4ZM7.5 6C8.32843 6 9 6.67157 9 7.5C9 8.32843 8.32843 9 7.5 9C6.67157 9 6 8.32843 6 7.5C6 6.67157 6.67157 6 7.5 6Z"
      fill="#FF5500"
    />
  ),
  scheduledOrders: (
    <g
      className="svg-fill"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <path d="M15,2 L15,1 C15,0.44771525 15.4477153,3.65416674e-15 16,3.55271368e-15 C16.5522847,3.45126062e-15 17,0.44771525 17,1 L17,2 L19.260521,2 C20.1967224,2 21,2.68990624 21,3.63511188 L21,20.3648881 C21,21.3100938 20.1967224,22 19.260521,22 L2.73947896,22 C1.8032776,22 1,21.3100938 1,20.3648881 L1,3.63511188 C1,2.68990624 1.8032776,2 2.73947896,2 L5,2 L5,1 C5,0.44771525 5.44771525,3.65416674e-15 6,3.55271368e-15 C6.55228475,3.45126062e-15 7,0.44771525 7,1 L7,2 L10,2 L10,1 C10,0.44771525 10.4477153,3.65416674e-15 11,3.55271368e-15 C11.5522847,3.45126062e-15 12,0.44771525 12,1 L12,2 L15,2 Z M15,4 L12,4 L12,5 C12,5.55228475 11.5522847,6 11,6 C10.4477153,6 10,5.55228475 10,5 L10,4 L7,4 L7,5 C7,5.55228475 6.55228475,6 6,6 C5.44771525,6 5,5.55228475 5,5 L5,4 L3,4 L3,20 L19,20 L19,4 L17,4 L17,5 C17,5.55228475 16.5522847,6 16,6 C15.4477153,6 15,5.55228475 15,5 L15,4 Z M11,8 L16,8 C16.5522847,8 17,8.44771525 17,9 C17,9.55228475 16.5522847,10 16,10 L11,10 C10.4477153,10 10,9.55228475 10,9 C10,8.44771525 10.4477153,8 11,8 Z M11,12 L16,12 C16.5522847,12 17,12.4477153 17,13 C17,13.5522847 16.5522847,14 16,14 L11,14 C10.4477153,14 10,13.5522847 10,13 C10,12.4477153 10.4477153,12 11,12 Z M11,16 L16,16 C16.5522847,16 17,16.4477153 17,17 C17,17.5522847 16.5522847,18 16,18 L11,18 C10.4477153,18 10,17.5522847 10,17 C10,16.4477153 10.4477153,16 11,16 Z M6,8 L7,8 C7.55228475,8 8,8.44771525 8,9 C8,9.55228475 7.55228475,10 7,10 L6,10 C5.44771525,10 5,9.55228475 5,9 C5,8.44771525 5.44771525,8 6,8 Z M6,12 L7,12 C7.55228475,12 8,12.4477153 8,13 C8,13.5522847 7.55228475,14 7,14 L6,14 C5.44771525,14 5,13.5522847 5,13 C5,12.4477153 5.44771525,12 6,12 Z M6,16 L7,16 C7.55228475,16 8,16.4477153 8,17 C8,17.5522847 7.55228475,18 7,18 L6,18 C5.44771525,18 5,17.5522847 5,17 C5,16.4477153 5.44771525,16 6,16 Z" />
    </g>
  ),
  lightning: (
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g>
        <circle
          id="Oval-5"
          className="svg-stroke"
          strokeWidth="2"
          fillRule="nonzero"
          cx="12"
          cy="12"
          r="10"
        />
        <polygon
          id="Shape"
          className="svg-fill"
          points="10.1825225 6 8 13.15 10.0452433 13.15 8.25954302 19 15.4127109 11.2 12.6857199 11.2 17 6"
        />
      </g>
    </g>
  ),
  list: (
    <path
      className="svg-fill"
      fillRule="nonzero"
      d="M16.4 11h-5.8c-.552 0-.6.447-.6 1 0 .553.048 1 .6 1h5.8c.552 0 .6-.447.6-1 0-.553-.048-1-.6-1zm2 5h-7.8c-.552 0-.6.447-.6 1 0 .553.048 1 .6 1h7.8c.552 0 .6-.447.6-1 0-.553-.048-1-.6-1zm-7.8-8h7.8c.552 0 .6-.447.6-1 0-.553-.048-1-.6-1h-7.8c-.552 0-.6.447-.6 1 0 .553.048 1 .6 1zm-3.2 3H5.6c-.552 0-.6.447-.6 1 0 .553.048 1 .6 1h1.8c.552 0 .6-.447.6-1 0-.553-.048-1-.6-1zm0 5H5.6c-.552 0-.6.447-.6 1 0 .553.048 1 .6 1h1.8c.552 0 .6-.447.6-1 0-.553-.048-1-.6-1zm0-10H5.6c-.552 0-.6.447-.6 1 0 .553.048 1 .6 1h1.8c.552 0 .6-.447.6-1 0-.553-.048-1-.6-1z"
    />
  ),
  folder: (
    <path
      className="svg-fill"
      fillRule="nonzero"
      d="M20.397 6.799c-.111-.44-.655-.799-1.21-.799h-6.814c-.554 0-1.33-.318-1.722-.707l-.596-.588C9.663 4.316 8.888 4 8.334 4H5.079c-.555 0-1.06.447-1.12.994L3.667 8h16.93l-.2-1.201zM21.404 9H2.58a.58.58 0 0 0-.577.635l.923 9.669a.77.77 0 0 0 .766.696h16.6a.77.77 0 0 0 .766-.696l.923-9.669A.58.58 0 0 0 21.404 9z"
    />
  ),
  growthEngineConfetti: (
    <g className="svg-fill">
      <path d="M12.3536 0.00078258C12.7558 0.000806696 13.1467 0.133797 13.4655 0.379053C13.7843 0.62431 14.013 0.968073 14.1162 1.35684C14.2193 1.7456 14.1911 2.15756 14.0358 2.52859C13.8805 2.89962 13.6069 3.20891 13.2576 3.40832V3.40832C13.1655 3.46081 13.069 3.50508 12.9692 3.54059V2.95356V1.6934L12.5336 2.38179L12.3704 2.63852L12.2076 2.38179L11.7665 1.68753L11.7587 2.94338C11.6144 2.86549 11.4831 2.76554 11.3697 2.64713L11.3873 1.03435C11.4624 0.94083 11.5517 0.859622 11.6519 0.793669L12.3696 1.91882L13.0862 0.781928C13.1932 0.844525 13.2851 0.929902 13.3554 1.032V2.87764L13.3813 2.85259C13.5629 2.67059 13.693 2.44363 13.7583 2.19489C13.8235 1.94616 13.8216 1.68456 13.7526 1.43682C13.6837 1.18908 13.5502 0.964084 13.3659 0.78481C13.1815 0.605537 12.9529 0.478413 12.7033 0.416425C12.4537 0.354436 12.1922 0.359806 11.9454 0.431984C11.6985 0.504162 11.4753 0.640562 11.2985 0.827251C11.1216 1.01394 10.9975 1.24422 10.9388 1.49458C10.8801 1.74494 10.8889 2.0064 10.9643 2.25225C11.0164 2.42472 11.1035 2.58459 11.2202 2.72188C11.3572 2.89579 11.5321 3.03613 11.7316 3.13223C11.931 3.22833 12.1498 3.27765 12.3712 3.27643V3.04905L12.912 3.56173C12.835 3.58556 12.7566 3.60451 12.6772 3.61847V3.61847C12.4281 3.66341 12.1723 3.65598 11.9262 3.59668C11.6801 3.53737 11.4491 3.42747 11.2478 3.27399C11.0465 3.12051 10.8793 2.92679 10.757 2.70518C10.6346 2.48356 10.5597 2.23891 10.5371 1.98677C10.5145 1.73464 10.5446 1.48056 10.6255 1.2407C10.7064 1.00083 10.8364 0.780447 11.0071 0.593563C11.1779 0.406679 11.3857 0.25739 11.6173 0.155199C11.8489 0.0530085 12.0992 0.000154199 12.3524 0L12.3536 0.00078258Z" />
      <path d="M22.1763 11.4285C22.5785 11.4285 22.9695 11.5615 23.2882 11.8068C23.607 12.052 23.8358 12.3958 23.9389 12.7846C24.0421 13.1733 24.0138 13.5853 23.8585 13.9563C23.7032 14.3274 23.4297 14.6366 23.0803 14.8361C22.9883 14.8885 22.8918 14.9328 22.7919 14.9683V14.3813V13.1211L22.3563 13.8095L22.1931 14.0663L22.0303 13.8095L21.5893 13.1153L21.5815 14.3711C21.4372 14.2932 21.3059 14.1933 21.1925 14.0749L21.2101 12.4621C21.2852 12.3686 21.3744 12.2874 21.4746 12.2214L22.1924 13.3466L22.9089 12.2097C23.0159 12.2723 23.1079 12.3576 23.1782 12.4597V14.3054L23.204 14.2803C23.3857 14.0983 23.5158 13.8714 23.581 13.6226C23.6463 13.3739 23.6443 13.1123 23.5754 12.8646C23.5065 12.6168 23.373 12.3918 23.1886 12.2125C23.0043 12.0333 22.7756 11.9061 22.5261 11.8442C22.2765 11.7822 22.0149 11.7875 21.7681 11.8597C21.5213 11.9319 21.2981 12.0683 21.1212 12.255C20.9444 12.4417 20.8203 12.672 20.7615 12.9223C20.7028 13.1727 20.7116 13.4341 20.787 13.68C20.8391 13.8525 20.9263 14.0123 21.043 14.1496C21.18 14.3235 21.3549 14.4639 21.5543 14.56C21.7538 14.6561 21.9725 14.7054 22.1939 14.7042V14.4768L22.7348 14.9895C22.6578 15.0133 22.5794 15.0322 22.5 15.0462V15.0462C22.2508 15.0911 21.9951 15.0837 21.749 15.0244C21.5029 14.9651 21.2718 14.8552 21.0705 14.7017C20.8692 14.5482 20.7021 14.3545 20.5797 14.1329C20.4574 13.9113 20.3825 13.6666 20.3598 13.4145C20.3372 13.1624 20.3673 12.9083 20.4482 12.6684C20.5292 12.4286 20.6591 12.2082 20.8299 12.0213C21.0007 11.8344 21.2084 11.6851 21.4401 11.5829C21.6717 11.4807 21.922 11.4279 22.1751 11.4277L22.1763 11.4285Z" />
      <path d="M18.9263 16.6095C18.793 16.6114 18.6606 16.5868 18.537 16.537C18.4133 16.4871 18.3008 16.4132 18.2061 16.3194C18.1114 16.2256 18.0363 16.1139 17.9852 15.9907C17.9342 15.8676 17.9082 15.7355 17.9088 15.6022C17.9072 15.4675 17.9323 15.3339 17.9827 15.209C18.0331 15.0842 18.1078 14.9706 18.2025 14.8748C18.2971 14.779 18.4098 14.703 18.5341 14.6511C18.6583 14.5992 18.7916 14.5725 18.9263 14.5725C19.1982 14.5741 19.4584 14.6831 19.6502 14.8759C19.8419 15.0687 19.9496 15.3295 19.9497 15.6014C19.9472 15.8706 19.8381 16.1279 19.6463 16.3169C19.4545 16.5059 19.1955 16.6111 18.9263 16.6095V16.6095ZM18.9318 15.9473C19.0251 15.9456 19.1141 15.9076 19.1799 15.8413C19.2456 15.775 19.283 15.6857 19.284 15.5924C19.2799 15.499 19.2409 15.4105 19.1746 15.3445C19.1084 15.2785 19.0197 15.2399 18.9263 15.2362C18.8788 15.2369 18.8318 15.247 18.7882 15.2658C18.7446 15.2847 18.7051 15.312 18.6721 15.3462C18.639 15.3804 18.6131 15.4208 18.5957 15.4651C18.5784 15.5093 18.57 15.5566 18.5709 15.6041C18.5715 15.6505 18.5813 15.6964 18.5999 15.7389C18.6184 15.7815 18.6453 15.8199 18.6789 15.8519C18.7126 15.8839 18.7523 15.9088 18.7957 15.9252C18.8391 15.9416 18.8854 15.9491 18.9318 15.9473V15.9473Z" />
      <path d="M20.1388 8.72192C20.1972 8.72192 20.2562 8.71918 20.3146 8.72192C20.3984 8.72305 20.4785 8.75707 20.5375 8.81666C20.5965 8.87625 20.6297 8.95663 20.63 9.04048C20.6335 9.22051 20.5149 9.3657 20.3357 9.37979C20.1994 9.39036 20.0626 9.39036 19.9263 9.37979C19.8432 9.37119 19.7665 9.33138 19.7116 9.2684C19.6567 9.20542 19.6277 9.12395 19.6306 9.04045C19.6334 8.95695 19.6678 8.87763 19.7268 8.81851C19.7859 8.75939 19.8651 8.72487 19.9486 8.72192C20.0116 8.71918 20.0754 8.72192 20.1388 8.72192Z" />
      <path d="M20.131 10.2468C20.1251 10.3995 20.0687 10.504 19.9478 10.5599C19.8269 10.6159 19.697 10.6139 19.5913 10.5228C19.4877 10.4336 19.3906 10.337 19.3009 10.2339C19.2524 10.175 19.2256 10.1012 19.2251 10.0248C19.2246 9.94851 19.2504 9.87433 19.2982 9.81479C19.3921 9.69738 19.5721 9.63985 19.6895 9.72908C19.839 9.8414 19.9635 9.98777 20.0922 10.1263C20.1231 10.1588 20.1228 10.2179 20.131 10.2468Z" />
      <path d="M18.9038 7.51513C18.9077 7.5833 18.9077 7.65163 18.9038 7.7198C18.8946 7.80053 18.8552 7.87478 18.7935 7.92758C18.7317 7.98038 18.6523 8.00781 18.5711 8.00432C18.4918 8.00452 18.4154 7.97461 18.3572 7.92064C18.2991 7.86667 18.2637 7.79265 18.258 7.71354C18.2486 7.57229 18.2486 7.43057 18.258 7.28931C18.2653 7.20971 18.3019 7.13564 18.3606 7.0814C18.4193 7.02716 18.4961 6.9966 18.576 6.99563C18.6559 6.99466 18.7334 7.02334 18.7934 7.07613C18.8534 7.12892 18.8918 7.20208 18.901 7.28149C18.9062 7.35926 18.9072 7.43725 18.9038 7.51513Z" />
      <path d="M17.7028 7.70124C17.7546 7.74564 17.8039 7.79294 17.8503 7.84291C17.9025 7.90515 17.929 7.98485 17.9247 8.06591C17.9203 8.14698 17.8853 8.22337 17.8268 8.27966C17.7722 8.33665 17.6981 8.3709 17.6193 8.37555C17.5404 8.38019 17.4628 8.35489 17.4018 8.30471C17.2931 8.21419 17.1904 8.11652 17.0946 8.01237C17.0403 7.95163 17.0112 7.87247 17.0133 7.79104C17.0153 7.7096 17.0483 7.632 17.1056 7.57405C17.1606 7.51757 17.2343 7.48308 17.3129 7.47703C17.3915 7.47098 17.4696 7.49378 17.5325 7.54117C17.5921 7.59146 17.6489 7.64489 17.7028 7.70124Z" />
      <path d="M18.9067 10.6032C18.9067 10.6666 18.911 10.7304 18.9067 10.7934C18.8914 10.9813 18.765 11.0994 18.5826 11.0998C18.5411 11.1019 18.4995 11.0957 18.4605 11.0813C18.4214 11.067 18.3856 11.045 18.3552 11.0165C18.3249 10.9881 18.3006 10.9538 18.2838 10.9157C18.267 10.8776 18.258 10.8366 18.2574 10.795C18.2508 10.6684 18.2508 10.5415 18.2574 10.415C18.2582 10.3315 18.2919 10.2518 18.3512 10.1931C18.4105 10.1345 18.4906 10.1017 18.574 10.1019C18.758 10.0984 18.8942 10.2244 18.9083 10.415C18.913 10.478 18.9083 10.5418 18.9083 10.6048L18.9067 10.6032Z" />
      <path d="M19.8906 8.19845C19.845 8.24927 19.7964 8.29736 19.7451 8.34247C19.6816 8.39314 19.6013 8.41781 19.5204 8.41149C19.4394 8.40517 19.3639 8.36832 19.3091 8.30842C19.2535 8.2524 19.2211 8.17744 19.2184 8.09856C19.2158 8.01968 19.243 7.9427 19.2946 7.88302C19.3877 7.77652 19.4877 7.67625 19.594 7.58285C19.6561 7.53011 19.736 7.50298 19.8174 7.50698C19.8988 7.51098 19.9757 7.5458 20.0323 7.60437C20.0874 7.66079 20.12 7.73533 20.1241 7.81404C20.1282 7.89276 20.1035 7.97029 20.0546 8.03213C20.0029 8.09035 19.9481 8.14587 19.8906 8.19845Z" />
      <path d="M11.007 12.8389C10.8505 12.8209 10.7495 12.7469 10.6939 12.6119C10.6682 12.5477 10.6639 12.4768 10.6817 12.4099C10.6996 12.3431 10.7386 12.2838 10.793 12.2409C10.8319 12.2116 10.8741 12.1868 10.9186 12.1669C13.2865 11.039 15.655 9.91169 18.024 8.78484C18.2612 8.67213 18.4592 8.7277 18.5406 8.92769C18.6118 9.10184 18.5426 9.26934 18.352 9.36131C17.8124 9.62247 17.2709 9.88168 16.7275 10.1389C14.9011 11.0085 13.0748 11.8775 11.2485 12.7458C11.171 12.7825 11.0876 12.808 11.007 12.8389Z" />
      <path d="M13.3506 13.5225C14.688 13.5298 16.0139 13.7702 17.2688 14.2328C17.4528 14.3009 17.5428 14.4171 17.5342 14.5756C17.524 14.8104 17.3099 14.9427 17.0685 14.8664C16.7241 14.7576 16.3832 14.6363 16.0349 14.5427C14.857 14.2226 13.6308 14.1196 12.416 14.2386C11.7464 14.3044 11.0831 14.432 10.4174 14.5357C10.1994 14.5697 10.0284 14.4746 9.99001 14.2844C9.95088 14.0888 10.0761 13.9213 10.2996 13.8868C10.9794 13.7815 11.6584 13.668 12.3405 13.5792C12.6743 13.5358 13.014 13.5397 13.3506 13.5225Z" />
      <path d="M8.61982 12.51C8.44802 12.4779 8.34353 12.4086 8.28874 12.2728C8.22808 12.1233 8.27308 11.9946 8.38853 11.8901C8.67813 11.6274 8.96865 11.3658 9.26008 11.1054C10.0918 10.3571 10.924 9.6094 11.7565 8.86217C11.8199 8.80239 11.8955 8.757 11.978 8.72911C12.117 8.68997 12.2676 8.77137 12.3322 8.90013C12.3647 8.96631 12.3746 9.04131 12.3605 9.11367C12.3464 9.18603 12.3089 9.25178 12.2539 9.30088C11.915 9.61044 11.573 9.91687 11.2317 10.2245C10.4623 10.9177 9.69266 11.6103 8.92273 12.3022C8.8292 12.3832 8.71883 12.4415 8.61982 12.51Z" />
      <path d="M8.58988 6.75265C8.58988 8.2621 8.24862 9.69486 7.64476 11.0713C7.52109 11.3526 7.40995 11.6391 7.28823 11.9217C7.26195 11.9908 7.21374 12.0494 7.15099 12.0886C7.08823 12.1278 7.01437 12.1453 6.94071 12.1385C6.7963 12.1193 6.66676 12.0125 6.65424 11.8645C6.65079 11.773 6.66818 11.6819 6.70511 11.598C6.93014 11.0313 7.18218 10.474 7.38646 9.90032C7.82602 8.66769 7.99851 7.35569 7.89249 6.05134C7.85844 5.60989 7.76843 5.17314 7.70385 4.73403C7.69149 4.67684 7.6839 4.61872 7.68116 4.56027C7.6828 4.48112 7.71343 4.40532 7.76724 4.34725C7.82106 4.28918 7.89431 4.25288 7.97311 4.24523C8.05404 4.23297 8.13656 4.2529 8.20298 4.30074C8.2694 4.34858 8.31444 4.42053 8.32846 4.50118C8.40477 4.91836 8.47991 5.33672 8.5304 5.75743C8.56953 6.08734 8.57149 6.42117 8.58988 6.75265Z" />
      <path d="M15.1192 7.14763C15.1192 7.42158 15.1192 7.69553 15.1192 7.96948C15.1192 8.23207 14.9963 8.35144 14.7302 8.35222C14.1925 8.35379 13.6546 8.35379 13.1166 8.35222C12.8611 8.35222 12.7386 8.22973 12.7374 7.97417C12.7353 7.42627 12.7353 6.87838 12.7374 6.33048C12.7374 6.0757 12.8548 5.96104 13.1045 5.96065C13.6524 5.95908 14.2003 5.95908 14.7482 5.96065C15.003 5.96065 15.1172 6.07257 15.1196 6.32539C15.1212 6.59973 15.1192 6.87368 15.1192 7.14763Z" />
      <path d="M10.6673 4.93391C10.9346 4.94084 11.1885 5.05247 11.3744 5.24476C11.5603 5.43705 11.6632 5.69463 11.6611 5.96206C11.6589 6.22948 11.5518 6.48537 11.3629 6.67464C11.1739 6.86391 10.9182 6.97143 10.6508 6.97405C10.3816 6.96956 10.1249 6.85994 9.93548 6.66862C9.74606 6.47731 9.63901 6.21948 9.63721 5.95027C9.63735 5.81568 9.6642 5.68246 9.71618 5.55832C9.76817 5.43418 9.84426 5.32159 9.94006 5.22706C10.0359 5.13254 10.1495 5.05796 10.2743 5.00764C10.3991 4.95732 10.5327 4.93226 10.6673 4.93391V4.93391ZM11.014 5.94557C11.0135 5.89921 11.0039 5.85341 10.9857 5.81077C10.9675 5.76814 10.9411 5.72951 10.9079 5.69712C10.8748 5.66472 10.8355 5.63919 10.7925 5.62199C10.7495 5.60479 10.7034 5.59625 10.6571 5.59687C10.5636 5.59805 10.4741 5.63538 10.4075 5.70104C10.3409 5.7667 10.3023 5.85559 10.2998 5.94909C10.3027 6.04518 10.3427 6.13639 10.4115 6.20359C10.4802 6.2708 10.5723 6.30876 10.6684 6.30953C10.7617 6.30481 10.8496 6.26439 10.914 6.19664C10.9783 6.12889 11.0141 6.03899 11.014 5.94557V5.94557Z" />
      <path d="M7.55634 3.52161C7.37869 3.52244 7.20794 3.45294 7.08137 3.32828C6.9548 3.20362 6.88272 3.03394 6.88086 2.8563C6.88403 2.679 6.95645 2.50997 7.08262 2.38536C7.20879 2.26074 7.3787 2.19043 7.55603 2.18946C7.73336 2.18849 7.90404 2.25693 8.03156 2.38016C8.15909 2.50338 8.23335 2.67161 8.23847 2.84887C8.23848 2.93801 8.22077 3.02626 8.18638 3.1085C8.15198 3.19074 8.10159 3.26532 8.03812 3.32792C7.97465 3.39051 7.89938 3.43987 7.81667 3.47312C7.73396 3.50637 7.64547 3.52285 7.55634 3.52161V3.52161Z" />
      <path d="M18.065 3.86809C18.0066 3.86809 17.9475 3.87004 17.8892 3.86809C17.8053 3.86872 17.7244 3.83705 17.6632 3.77964C17.602 3.72223 17.5652 3.64348 17.5605 3.5597C17.556 3.47313 17.5855 3.38823 17.6427 3.32304C17.6998 3.25786 17.7801 3.21752 17.8665 3.21061C17.9981 3.19965 18.1303 3.19965 18.2618 3.21061C18.3481 3.21752 18.4284 3.25756 18.4858 3.32235C18.5432 3.38714 18.5733 3.47164 18.5698 3.55813C18.5581 3.73737 18.4184 3.86378 18.2262 3.86848C18.1726 3.86926 18.119 3.86848 18.065 3.86809Z" />
      <path d="M16.8797 2.67642C16.8797 2.60793 16.875 2.53944 16.8797 2.47174C16.8854 2.39572 16.9182 2.32427 16.972 2.2703C17.0258 2.21633 17.0972 2.18339 17.1732 2.17744C17.3376 2.16413 17.4957 2.26549 17.5168 2.4283C17.5368 2.5875 17.5387 2.74848 17.5223 2.9081C17.5121 2.98908 17.471 3.063 17.4077 3.11447C17.3443 3.16594 17.2635 3.19098 17.1822 3.1844C17.1006 3.17919 17.0239 3.14344 16.9675 3.08426C16.9111 3.02507 16.879 2.94681 16.8777 2.86505C16.8738 2.80204 16.8777 2.73825 16.8777 2.67485L16.8797 2.67642Z" />
      <path d="M16.3421 3.86819C16.2885 3.86819 16.2349 3.86819 16.1812 3.86819C15.9856 3.86349 15.8521 3.73982 15.8431 3.55745C15.84 3.51347 15.8458 3.46931 15.8602 3.42766C15.8747 3.386 15.8974 3.3477 15.9271 3.3151C15.9568 3.28249 15.9928 3.25626 16.0329 3.23797C16.073 3.21969 16.1164 3.20975 16.1605 3.20875C16.2823 3.20092 16.4046 3.20092 16.5264 3.20875C16.5705 3.21012 16.6138 3.22037 16.6538 3.23889C16.6938 3.25741 16.7296 3.28381 16.7591 3.31653C16.7887 3.34924 16.8113 3.38758 16.8256 3.42925C16.84 3.47092 16.8458 3.51505 16.8426 3.55901C16.8344 3.73943 16.699 3.86349 16.5029 3.86819C16.4493 3.86936 16.3957 3.86819 16.3421 3.86819Z" />
      <path d="M16.8775 4.40325C16.8775 4.33985 16.874 4.27646 16.8775 4.21345C16.8881 4.0389 17.0047 3.91719 17.1683 3.90506C17.3553 3.89136 17.5017 3.99077 17.5205 4.17431C17.5381 4.32884 17.5373 4.4849 17.5181 4.63924C17.4958 4.81496 17.3514 4.91006 17.1698 4.89793C17.0051 4.88736 16.8873 4.76682 16.8759 4.59306C16.8744 4.53005 16.8775 4.46665 16.8775 4.40325Z" />
      <path d="M2.04505 2.19708C2.11193 2.19238 2.1786 2.20872 2.23573 2.24381C2.29285 2.2789 2.33757 2.33098 2.36362 2.39276C2.49081 2.65653 2.618 2.92069 2.75497 3.17977C2.77132 3.20764 2.79312 3.23192 2.81908 3.25115C2.84504 3.27038 2.87462 3.28418 2.90603 3.2917C3.20855 3.3461 3.51342 3.38876 3.8175 3.43376C3.88168 3.44024 3.94233 3.46622 3.99131 3.5082C4.04028 3.55018 4.07523 3.60614 4.09145 3.66858C4.13059 3.79772 4.09145 3.91004 3.99752 4.00279C3.78932 4.20943 3.5823 4.41763 3.36783 4.61761C3.33248 4.64684 3.30629 4.68564 3.29241 4.72937C3.27853 4.7731 3.27754 4.81989 3.28956 4.86417C3.34083 5.14242 3.38662 5.42185 3.43319 5.70088C3.45667 5.84099 3.43045 5.96779 3.30717 6.0531C3.1839 6.13842 3.05005 6.12746 2.91895 6.0578C2.66887 5.92513 2.41528 5.79794 2.16794 5.66018C2.13149 5.63724 2.08916 5.62536 2.0461 5.62599C2.00303 5.62661 1.96107 5.63972 1.9253 5.66371C1.68148 5.79794 1.43297 5.92318 1.1872 6.05506C1.05179 6.12707 0.91521 6.14507 0.787629 6.04919C0.660047 5.95331 0.638131 5.82338 0.670222 5.66879C0.727751 5.38193 0.775888 5.09272 0.81698 4.80272C0.817531 4.77293 0.812139 4.74333 0.801119 4.71564C0.790099 4.68796 0.773672 4.66275 0.752798 4.64149C0.550337 4.43563 0.343832 4.23408 0.133283 4.03684C0.0158761 3.92844 -0.0283465 3.80203 0.0182247 3.65331C0.0616651 3.51516 0.171636 3.44942 0.316046 3.42985C0.606432 3.39071 0.89486 3.33905 1.18525 3.30344C1.27839 3.29209 1.31987 3.24709 1.35627 3.17116C1.48111 2.91169 1.61182 2.65457 1.73706 2.3951C1.76136 2.33412 1.80411 2.28225 1.85933 2.24675C1.91455 2.21125 1.97948 2.19388 2.04505 2.19708V2.19708Z" />
      <path d="M11.7456 17.7803L10.2811 18.3364C10.0115 18.4386 9.74341 18.5438 9.47142 18.6378C9.40097 18.6635 9.32389 18.6648 9.25265 18.6413C6.14959 17.3373 4.17169 15.0604 3.34319 11.7926C3.33343 11.7553 3.32908 11.7168 3.33027 11.6783C3.33462 11.6445 3.34235 11.6112 3.35336 11.5789C3.4829 11.0537 3.61205 10.5285 3.75098 9.96533C4.53956 11.757 5.71089 13.2347 7.0681 14.5708C8.42532 15.9069 9.91365 17.0786 11.7456 17.7803Z" />
      <path d="M8.38526 19.052C7.9215 19.2285 7.48905 19.3929 7.05465 19.5569C6.2238 19.87 5.39217 20.1831 4.56328 20.5028C4.4537 20.5451 4.386 20.5298 4.2952 20.4531C3.41387 19.7095 2.84915 18.7785 2.63899 17.6459C2.56346 17.2393 2.5435 16.8241 2.50358 16.4092C2.47697 16.1353 2.44331 15.8637 2.44488 15.5909C2.45142 15.3833 2.48055 15.177 2.53176 14.9757C2.67265 14.3675 2.82527 13.7625 2.9826 13.116C4.00991 15.8104 5.79723 17.7758 8.38526 19.052Z" />
      <path d="M0.835938 21.9096L1.89651 17.5613C2.11958 18.8704 2.70035 19.9485 3.66152 20.8401L0.835938 21.9096Z" />
      <path d="M19.5298 21.5694C19.4907 21.7538 19.4668 21.9424 19.4124 22.122C19.2081 22.801 18.5491 23.2127 17.8709 23.0949C17.545 23.0384 17.2506 22.8659 17.042 22.6093C16.8333 22.3526 16.7247 22.0291 16.7359 21.6986C16.7539 21.2086 17.0099 20.8443 17.3801 20.5476C17.6424 20.3363 17.9535 20.1941 18.2849 20.134C18.2399 20.0796 18.2094 20.0377 18.1742 20.0013C17.4956 19.2992 16.6823 18.844 15.7188 18.6656C15.5623 18.6362 15.4241 18.5791 15.385 18.4049C15.331 18.1662 15.5024 17.9545 15.7478 18.0085C16.1552 18.0997 16.5673 18.1999 16.952 18.358C17.9186 18.7556 18.6759 19.4178 19.2531 20.2889C19.3147 20.3815 19.3927 20.462 19.4833 20.5265C20.4616 21.2168 20.7841 22.54 20.2202 23.5908C20.1687 23.6822 20.0897 23.7551 19.9944 23.799C19.9349 23.8246 19.8685 23.8294 19.806 23.8124C19.7435 23.7954 19.6887 23.7577 19.6504 23.7055C19.5498 23.5814 19.5513 23.4452 19.6234 23.3082C19.8476 22.8813 19.8993 22.4359 19.7525 21.9776C19.7063 21.832 19.6296 21.6962 19.567 21.5561L19.5298 21.5694ZM18.8755 21.4853C18.8399 21.3288 18.8215 21.1722 18.7679 21.0266C18.6951 20.831 18.5354 20.7601 18.3303 20.8028C17.9992 20.8717 17.7402 21.056 17.5425 21.3237C17.3637 21.5659 17.3406 21.8324 17.4928 22.0935C17.6404 22.349 17.8717 22.4684 18.1679 22.4402C18.4642 22.412 18.6594 22.2528 18.7549 21.9827C18.814 21.8242 18.8367 21.6536 18.8755 21.4853V21.4853Z" />
    </g>
  ),
  supportBuoy: (
    <path
      className="svg-fill"
      fillRule="nonzero"
      d="M20.485 3.515c-4.686-4.687-12.284-4.687-16.969 0-4.688 4.687-4.688 12.284-.002 16.97 4.687 4.687 12.285 4.687 16.972 0 4.685-4.687 4.685-12.284 0-16.97zM7.758 15.389c-2.344-2.15-2.344-5.631 0-7.778 2.34-2.148 6.141-2.148 8.485 0 2.344 2.148 2.341 5.63 0 7.778-2.344 2.148-6.141 2.148-8.485 0zM19 15.75c1.056-2.343 1.057-5.156 0-7.5L20.945 7c1.406 3.114 1.406 6.89.002 10L19 15.751zM17 3.053L15.748 5c-2.343-1.055-5.156-1.055-7.496 0L7 3.054c3.113-1.405 6.886-1.405 10 0zM3.054 7L5 8.252c-1.056 2.341-1.056 5.153-.001 7.496L3.053 17c-1.405-3.111-1.404-6.886.001-10zM7 20.945L8.251 19c2.342 1.057 5.156 1.057 7.498 0L17 20.947c-3.114 1.404-6.887 1.404-10-.002z"
    />
  ),
  youtube: (
    <g
      id="SelfOnboarding_Example-screens"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="Supplier_CreateTrial_success"
        transform="translate(-831.000000, -355.000000)"
      >
        <g id="Group" transform="translate(571.000000, 355.000000)">
          <g id="Youtube" transform="translate(260.000000, 0.000000)">
            <path
              d="M19.78,38.8106 L19.78,38.8106 C9.27,38.8106 0.75,30.2906 0.75,19.7806 C0.75,9.2706 9.27,0.7496 19.78,0.7496 C30.291,0.7496 38.811,9.2706 38.811,19.7806 C38.811,30.2906 30.291,38.8106 19.78,38.8106 Z"
              id="Stroke-1"
              stroke="#222221"
              strokeWidth="1.5"
            />
            <path
              d="M34.3747,12.4014 C34.0237,11.0824 32.9917,10.0434 31.6817,9.6904 C29.3067,9.0494 19.7797,9.0494 19.7797,9.0494 C19.7797,9.0494 10.2547,9.0494 7.8797,9.6904 C6.5687,10.0434 5.5367,11.0824 5.1867,12.4014 C4.5497,14.7924 4.5497,19.7804 4.5497,19.7804 C4.5497,19.7804 4.5497,24.7684 5.1867,27.1604 C5.5367,28.4794 6.5687,29.5174 7.8797,29.8704 C10.2547,30.5104 19.7797,30.5104 19.7797,30.5104 C19.7797,30.5104 29.3067,30.5104 31.6817,29.8704 C32.9917,29.5174 34.0237,28.4794 34.3747,27.1604 C35.0117,24.7684 35.0117,19.7804 35.0117,19.7804 C35.0117,19.7804 35.0117,14.7924 34.3747,12.4014"
              id="Fill-3"
              fill="#222221"
            />
            <polygon
              id="Fill-5"
              fill="#FFFFFF"
              points="16.6648 24.3096 16.6648 15.2506 24.6268 19.7806"
            />
          </g>
        </g>
      </g>
    </g>
  ),
  error: (
    <g>
      <g className="svg-stroke" fill="none" fillRule="evenodd">
        <path
          d="M11 21c5.52 0 10-4.48 10-10S16.52 1 11 1 1 5.48 1 11s4.48 10 10 10z"
          strokeWidth="2"
        />
      </g>
      <g className="svg-fill">
        <path d="M15.243 13.828l-1.415 1.415-7.07-7.071 1.414-1.415z" />
        <path d="M13.828 6.757l1.415 1.415-7.071 7.07-1.415-1.414z" />
      </g>
    </g>
  ),
  circlePlus: (
    <g transform="translate(3 3)" fill="none" fillRule="evenodd">
      <circle className="svg-stroke" strokeWidth="2" cx="9" cy="9" r="9" />
      <path className="svg-fill" d="M8 5h2v8H8z" />
      <path className="svg-fill" d="M13 8v2H5V8z" />
    </g>
  ),
  zoomIn: (
    <g>
      <path
        className="svg-stroke"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeMiterlimit="10"
        d="M7.3 10.8h7.1M10.9 14.3v-7"
      />
      <path
        className="svg-fill"
        d="M22.4 20.5l-4-4c3.2-4.1 2.4-10.1-1.8-13.2S6.5.9 3.3 5.1 1 15.2 5.1 18.3c1.6 1.2 3.7 2 5.8 2s4.1-.7 5.7-2l4 4M10.9 3.8c3.9 0 7.1 3.1 7.1 7 0 1.4-.4 2.8-1.3 4-.4.7-1.1 1.2-1.8 1.8-1.2.8-2.6 1.2-4 1.2-3.9 0-7.1-3.1-7.1-7s3.2-7 7.1-7z"
      />
    </g>
  ),
  zoomOut: (
    <g>
      <path
        className="svg-stroke"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeMiterlimit="10"
        d="M7.5 10.8h7"
      />
      <path
        className="svg-fill"
        d="M22.4 20.5l-4-4c3.2-4.1 2.4-10.1-1.8-13.2S6.5.9 3.3 5.1 1 15.2 5.1 18.3c1.6 1.2 3.7 2 5.8 2s4.1-.7 5.7-2l4 4M10.9 3.8c3.9 0 7.1 3.1 7.1 7 0 1.4-.4 2.8-1.3 4-.4.7-1.1 1.2-1.8 1.8-1.2.8-2.6 1.2-4 1.2-3.9 0-7.1-3.1-7.1-7s3.2-7 7.1-7z"
      />
    </g>
  ),
  rotateCCW: (
    <g>
      <path
        fill="none"
        className="svg-stroke"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeMiterlimit="10"
        d="M6.2 5.3c1.6-1.5 3.9-2.5 6.3-2.5 5.1 0 9.3 4.1 9.3 9.2"
      />
      <path
        d="M21.8 12c0 5.1-4.1 9.2-9.2 9.2-3.3 0-6-1.6-7.7-4.2"
        fill="none"
        className="svg-stroke"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeDasharray="3,4"
      />
      <path
        fill="none"
        className="svg-stroke"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeMiterlimit="10"
        d="M4.6 7.5c1.5-2.9 4.5-4.7 8-4.7 5.1 0 9.2 4.1 9.2 9.2"
      />
      <path
        className="svg-fill"
        d="M4.8 3.7l3.3 3c.6.5.4 1.5-.4 1.7L3.5 9.7c-.8.2-1.5-.5-1.3-1.2l.9-4.3c.2-.8 1.1-1.1 1.7-.5z"
      />
    </g>
  ),
  rotateCW: (
    <g>
      <path
        fill="none"
        className="svg-stroke"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeMiterlimit="10"
        d="M17.8,5.3c-1.6-1.5-3.9-2.5-6.3-2.5c-5.1,0-9.3,4.1-9.3,9.2"
      />
      <path
        d="M2.2,12c0,5.1,4.1,9.2,9.2,9.2c3.3,0,6-1.6,7.7-4.2"
        fill="none"
        className="svg-stroke"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeDasharray="3,4"
      />
      <path
        fill="none"
        className="svg-stroke"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeMiterlimit="10"
        d="M19.4,7.5c-1.5-2.9-4.5-4.7-8-4.7c-5.1,0-9.2,4.1-9.2,9.2"
      />
      <path
        className="svg-fill"
        d="M19.2,3.7l-3.3,3c-0.6,0.5-0.4,1.5,0.4,1.7l4.2,1.3c0.7,0.2,1.4-0.4,1.3-1.2l-0.9-4.3C20.7,3.4,19.8,3.1,19.2,3.7z"
      />
    </g>
  ),
  fitToWidth: (
    <g>
      <line
        className="svg-stroke"
        fill="none"
        strokeLinecap="round"
        strokeMiterlimit="10"
        x1="1.6"
        y1="5.3"
        x2="1.6"
        y2="18.8"
      />
      <line
        className="svg-stroke"
        fill="none"
        strokeLinecap="round"
        strokeMiterlimit="10"
        x1="22.4"
        y1="5.3"
        x2="22.4"
        y2="18.8"
      />
      <line
        className="svg-stroke"
        strokeWidth="2.5px"
        strokeLinecap="round"
        strokeMiterlimit="10"
        x1="3.6"
        y1="12.1"
        x2="5.9"
        y2="9.8"
      />
      <line
        className="svg-stroke"
        strokeWidth="2.5px"
        strokeLinecap="round"
        strokeMiterlimit="10"
        x1="3.6"
        y1="12.1"
        x2="5.9"
        y2="14.4"
      />
      <line
        className="svg-stroke"
        strokeWidth="2.5px"
        strokeLinecap="round"
        strokeMiterlimit="10"
        x1="20.4"
        y1="12.1"
        x2="18.1"
        y2="14.4"
      />
      <line
        className="svg-stroke"
        strokeWidth="2.5px"
        strokeLinecap="round"
        strokeMiterlimit="10"
        x1="20.4"
        y1="12.1"
        x2="18.1"
        y2="9.8"
      />
      <line
        className="svg-stroke"
        strokeWidth="2.5px"
        strokeLinecap="round"
        strokeMiterlimit="10"
        x1="3.7"
        y1="12.1"
        x2="20.1"
        y2="12.1"
      />
    </g>
  ),
  fitToHeight: (
    <g>
      <line
        className="svg-stroke"
        fill="none"
        strokeLinecap="round"
        strokeMiterlimit="10"
        x1="5.3"
        y1="22.4"
        x2="18.8"
        y2="22.4"
      />
      <line
        className="svg-stroke"
        fill="none"
        strokeLinecap="round"
        strokeMiterlimit="10"
        x1="5.3"
        y1="1.6"
        x2="18.8"
        y2="1.6"
      />
      <line
        className="svg-stroke"
        strokeWidth="2.5px"
        strokeLinecap="round"
        strokeMiterlimit="10"
        x1="12.1"
        y1="20.4"
        x2="9.8"
        y2="18.1"
      />
      <line
        className="svg-stroke"
        strokeWidth="2.5px"
        strokeLinecap="round"
        strokeMiterlimit="10"
        x1="12.1"
        y1="20.4"
        x2="14.3"
        y2="18.1"
      />
      <line
        className="svg-stroke"
        strokeWidth="2.5px"
        strokeLinecap="round"
        strokeMiterlimit="10"
        x1="12.1"
        y1="3.7"
        x2="14.3"
        y2="6"
      />
      <line
        className="svg-stroke"
        strokeWidth="2.5px"
        strokeLinecap="round"
        strokeMiterlimit="10"
        x1="12.1"
        y1="3.7"
        x2="9.8"
        y2="6"
      />
      <line
        className="svg-stroke"
        strokeWidth="2.5px"
        strokeLinecap="round"
        strokeMiterlimit="10"
        x1="12.1"
        y1="20.3"
        x2="12.1"
        y2="3.9"
      />
    </g>
  ),
  backNavigation: (
    <g transform="translate(0 2)">
      <path
        className="svg-fill"
        d="M19.22 7.215H2.41L8.25999 1.325C8.55999 1.025 8.55999 0.525 8.25999 0.225C7.95999 -0.075 7.47 -0.075 7.17 0.225L0.880005 6.565C0.760005 6.685 0.559999 6.895 0.389999 7.085C0.249999 7.235 0.150006 7.425 0.100006 7.635C0.0300061 7.765 0 7.885 0 8.005C0 8.125 0.0299963 8.245 0.0899963 8.335C0.149996 8.575 0.249999 8.765 0.389999 8.915C0.569999 9.105 0.769999 9.315 0.889999 9.435L7.18001 15.765C7.33001 15.915 7.52 15.995 7.73 15.995C7.94 15.995 8.13 15.915 8.28 15.765C8.43 15.615 8.50999 15.425 8.50999 15.215C8.50999 15.005 8.43 14.815 8.28 14.665L2.43001 8.775H19.24C19.67 8.775 20.01 8.425 20.01 7.995C19.99 7.565 19.65 7.215 19.22 7.215Z"
      />
    </g>
  ),
  padlockFill: (
    <path
      d="M16.3203 9.03449H15.4974C15.4974 8.09162 15.4974 7.15732 15.4888 6.21444C15.4888 5.75158 15.446 5.34871 15.3688 4.98014C14.9745 3.02582 13.6459 1.42293 11.7259 0.58292C9.81445 -0.257094 7.67156 -0.188521 5.86296 0.788638C3.80578 1.89437 2.65719 3.62583 2.54576 5.80301C2.48576 6.82303 2.49433 7.85161 2.5029 8.84592C2.5029 8.90592 2.5029 8.97449 2.5029 9.03449H1.68003C0.754298 9.03449 0 9.74593 0 10.6288V22.3976C0 23.289 0.754298 24.0005 1.68003 24.0005H16.3203C17.246 24.0005 18.0003 23.289 18.0003 22.4061V10.6288C18.0003 9.74593 17.246 9.03449 16.3203 9.03449ZM5.0658 5.92301C5.13437 4.5687 5.80295 3.5744 7.10583 2.87153C8.203 2.28009 9.50587 2.23723 10.6802 2.75153C11.8545 3.26582 12.6688 4.24298 12.9088 5.42586C12.9516 5.64872 12.9774 5.91444 12.9774 6.22302C12.9859 7.14875 12.9859 8.0659 12.9859 8.99163H5.03151C5.03151 8.93163 5.03151 8.87163 5.03151 8.81163C5.02294 7.86876 5.01437 6.87445 5.0658 5.92301ZM10.303 17.2889C10.543 18.2746 10.7745 19.2518 11.0059 20.2547C9.66016 20.2547 8.33157 20.2547 6.97726 20.2547C7.20012 19.2604 7.40584 18.2832 7.6287 17.3061C7.67156 17.1089 7.65441 16.9803 7.45727 16.8432C6.59154 16.226 6.31725 15.0774 6.78011 14.1089C7.23441 13.166 8.34014 12.626 9.38587 12.8231C10.5173 13.0374 11.3059 13.8946 11.3402 14.9574C11.3659 15.7375 11.0573 16.3803 10.4145 16.8603C10.2516 16.9889 10.2602 17.1175 10.303 17.2889Z"
      className="svg-fill"
    />
  ),
  bell: (
    <g>
      <line
        x1="9"
        y1="21"
        x2="15"
        y2="21"
        className="svg-stroke"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.9997 13.3449C17.9997 14.6544 18.38 15.921 19.075 17H4.92444C5.61937 15.921 5.99966 14.6545 5.99967 13.3451L5.99968 9.92465C5.99969 8.08354 6.86652 6.34987 8.33942 5.2452L8.35123 5.23634C8.38571 5.2099 8.42048 5.18382 8.45554 5.15811L8.67059 4.99682C8.89466 4.82877 9.138 4.68809 9.39544 4.57775C9.49594 4.53468 9.59732 4.49434 9.69946 4.45673C10.4079 4.16245 11.1848 4 11.9997 4C13.3724 4 14.6374 4.46096 15.6484 5.23655L15.8819 5.41168C17.2151 6.41155 17.9997 7.98074 17.9997 9.64718V9.99032C17.9997 9.99355 17.9997 9.99677 17.9997 10C17.9997 10.0032 17.9997 10.0064 17.9997 10.0097V13.3449ZM3.99968 9.92465C3.99969 7.45402 5.16292 5.12758 7.13942 3.6452L7.47059 3.39682C7.82207 3.13321 8.20378 2.91253 8.6076 2.73946C10.4706 1.94103 12.5619 1.85405 14.4847 2.49501L15.0029 2.66772C15.6631 2.8878 16.2835 3.21287 16.8403 3.63044L17.0819 3.81168C18.9187 5.18926 19.9997 7.35122 19.9997 9.64718V13.3449C19.9997 14.7144 20.5909 16.0173 21.6215 16.9191C22.4466 17.6411 21.936 19 20.8397 19H3.15994C2.06363 19 1.553 17.6411 2.37801 16.9191C3.40855 16.0173 3.99966 14.7145 3.99967 13.3451L3.99968 9.92465Z"
        className="svg-fill"
      />
    </g>
  ),
  support: (
    <g fill="none">
      <circle cx="12" cy="12" r="9" className="svg-stroke" strokeWidth="2" />
      <circle cx="12" cy="12" r="5.5" className="svg-stroke" />
      <line
        x1="15.4746"
        y1="15.7678"
        x2="17.596"
        y2="17.8891"
        className="svg-stroke"
      />
      <line
        x1="18.3536"
        y1="6.35355"
        x2="16.3536"
        y2="8.35355"
        className="svg-stroke"
      />
      <line
        x1="6.35355"
        y1="5.64645"
        x2="8.35355"
        y2="7.64645"
        className="svg-stroke"
      />
      <line
        x1="5.64645"
        y1="17.6464"
        x2="7.64645"
        y2="15.6464"
        className="svg-stroke"
      />
    </g>
  ),
  user: (
    <g fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.7118 12.7144C17.1054 11.6157 18 9.91232 18 8C18 4.68629 15.3137 2 12 2C8.68629 2 6 4.68629 6 8C6 9.91232 6.89463 11.6157 8.28819 12.7144C8.24977 12.7298 8.21142 12.7454 8.17317 12.7612C6.95991 13.2638 5.85752 14.0003 4.92893 14.9289C4.00035 15.8575 3.26375 16.9599 2.7612 18.1732C2.25866 19.3864 2 20.6868 2 22H4C4 20.9494 4.20693 19.9091 4.60896 18.9385C5.011 17.9679 5.60028 17.086 6.34315 16.3431C7.08601 15.6003 7.96793 15.011 8.93853 14.609C9.90914 14.2069 10.9494 14 12 14C13.0506 14 14.0909 14.2069 15.0615 14.609C16.0321 15.011 16.914 15.6003 17.6569 16.3431C18.3997 17.086 18.989 17.9679 19.391 18.9385C19.7931 19.9091 20 20.9494 20 22H22C22 20.6868 21.7413 19.3864 21.2388 18.1732C20.7362 16.9599 19.9997 15.8575 19.0711 14.9289C18.1425 14.0003 17.0401 13.2638 15.8268 12.7612C15.7886 12.7454 15.7502 12.7298 15.7118 12.7144ZM12 12C14.2091 12 16 10.2091 16 8C16 5.79086 14.2091 4 12 4C9.79086 4 8 5.79086 8 8C8 10.2091 9.79086 12 12 12Z"
        className="svg-fill"
      />
    </g>
  ),
  newTab: (
    <g fill="none">
      <path
        d="M12 6C12.5523 6 13 5.55228 13 5C13 4.44772 12.5523 4 12 4V6ZM20 12C20 11.4477 19.5523 11 19 11C18.4477 11 18 11.4477 18 12H20ZM12 4H7V6H12V4ZM4 7V17H6V7H4ZM7 20H17V18H7V20ZM20 17V12H18V17H20ZM17 20C18.6569 20 20 18.6569 20 17H18C18 17.5523 17.5523 18 17 18V20ZM4 17C4 18.6569 5.34315 20 7 20V18C6.44772 18 6 17.5523 6 17H4ZM7 4C5.34315 4 4 5.34315 4 7H6C6 6.44772 6.44772 6 7 6V4Z"
        fill="#8E8E8E"
      />
      <path
        d="M11.1464 11.1464C10.9512 11.3417 10.9512 11.6583 11.1464 11.8536C11.3417 12.0488 11.6583 12.0488 11.8536 11.8536L11.1464 11.1464ZM19.5 3.5H20C20 3.22386 19.7761 3 19.5 3V3.5ZM19 7.5C19 7.77614 19.2239 8 19.5 8C19.7761 8 20 7.77614 20 7.5H19ZM15.5 3C15.2239 3 15 3.22386 15 3.5C15 3.77614 15.2239 4 15.5 4V3ZM11.8536 11.8536L19.8536 3.85355L19.1464 3.14645L11.1464 11.1464L11.8536 11.8536ZM19 3.5V7.5H20V3.5H19ZM19.5 3H15.5V4H19.5V3Z"
        fill="#8E8E8E"
      />
    </g>
  ),
  userLineCircle: (
    <g fill="none">
      <circle cx="20" cy="20" r="20" fill="#F0F0F0" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.7118 20.7144C25.1054 19.6157 26 17.9123 26 16C26 12.6863 23.3137 10 20 10C16.6863 10 14 12.6863 14 16C14 17.9123 14.8946 19.6157 16.2882 20.7144C16.2498 20.7298 16.2114 20.7454 16.1732 20.7612C14.9599 21.2638 13.8575 22.0003 12.9289 22.9289C12.0003 23.8575 11.2638 24.9599 10.7612 26.1732C10.2587 27.3864 10 28.6868 10 30H12C12 28.9494 12.2069 27.9091 12.609 26.9385C13.011 25.9679 13.6003 25.086 14.3431 24.3431C15.086 23.6003 15.9679 23.011 16.9385 22.609C17.9091 22.2069 18.9494 22 20 22C21.0506 22 22.0909 22.2069 23.0615 22.609C24.0321 23.011 24.914 23.6003 25.6569 24.3431C26.3997 25.086 26.989 25.9679 27.391 26.9385C27.7931 27.9091 28 28.9494 28 30H30C30 28.6868 29.7413 27.3864 29.2388 26.1732C28.7362 24.9599 27.9997 23.8575 27.0711 22.9289C26.1425 22.0003 25.0401 21.2638 23.8268 20.7612C23.7886 20.7454 23.7502 20.7298 23.7118 20.7144ZM20 20C22.2091 20 24 18.2091 24 16C24 13.7909 22.2091 12 20 12C17.7909 12 16 13.7909 16 16C16 18.2091 17.7909 20 20 20Z"
        className="svg-fill"
      />
    </g>
  ),
  hamburgerMobile: (
    <g fill="none">
      <line
        x1="3"
        y1="4"
        x2="21"
        y2="4"
        className="svg-stroke"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <line
        x1="3"
        y1="12"
        x2="21"
        y2="12"
        className="svg-stroke"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <line
        x1="3"
        y1="20"
        x2="21"
        y2="20"
        className="svg-stroke"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  ),
  magnifyingGlass: (
    <g fill="none">
      <circle
        cx="8.5"
        cy="8.5"
        r="7.5"
        className="svg-stroke"
        strokeWidth="2"
      />
      <path
        d="M18.331 19.7433C18.7415 20.1128 19.3738 20.0795 19.7433 19.669C20.1128 19.2585 20.0795 18.6262 19.669 18.2567L18.331 19.7433ZM13.331 15.2433L18.331 19.7433L19.669 18.2567L14.669 13.7567L13.331 15.2433Z"
        className="svg-fill"
      />
    </g>
  ),
  copy: (
    <g fill="none">
      <path
        d="M3 6H1V18H13V16"
        className="svg-stroke"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.09692 1H18V13H6L6.09692 1Z"
        className="svg-stroke"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  ),
  bulbOutline: (
    <g fill="none">
      <path
        className="svg-fill"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 16C12.5523 16 13 16.4477 13 17C13 17.5523 12.5523 18 12 18H8C7.44772 18 7 17.5523 7 17C7 16.4477 7.44772 16 8 16H12ZM9.99976 2C13.5154 2 16 4.14732 16 7.55614C16 9.03449 15.4264 10.2346 14.3487 11.5712L13.4566 12.6387L13.3379 12.7907L13.2369 12.9317L13.1392 13.0851C13.0951 13.6025 12.6622 14 12.1429 14H7.85714C7.33783 14 6.90495 13.6025 6.86077 13.0851L6.76306 12.9317L6.66209 12.7906L6.54339 12.6386L5.65131 11.5711C4.5737 10.2346 4 9.03449 4 7.5562C4 4.1474 6.4845 2 9.99976 2ZM9.99976 4C7.52954 4 6 5.32201 6 7.5562C6 8.4132 6.33277 9.1752 7.02715 10.0851L7.29685 10.4232L7.68221 10.8819L8.17355 11.4747C8.31871 11.6608 8.4408 11.8331 8.53989 12H11.4601L11.5669 11.831C11.6432 11.7167 11.7297 11.5988 11.8265 11.4747L12.7917 10.3159L12.9729 10.0852C13.6673 9.17525 14 8.41325 14 7.5562C14 5.32197 12.4704 4 9.99976 4Z"
        fill="white"
      />
    </g>
  ),
  questionMarkCircled: (
    <g className="svg-fill">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4ZM12 16C12.5523 16 13 16.4477 13 17C13 17.5523 12.5523 18 12 18C11.4477 18 11 17.5523 11 17C11 16.4477 11.4477 16 12 16ZM12 6C14.2091 6 16 7.79086 16 10C16 11.7948 14.8179 13.3135 13.1898 13.8201L13 13.874V14C13 14.5523 12.5523 15 12 15C11.4872 15 11.0645 14.614 11.0067 14.1166L11 14V13C11 12.4872 11.386 12.0645 11.8834 12.0067L12.1493 11.9945C13.1841 11.9182 14 11.0544 14 10C14 8.89543 13.1046 8 12 8C10.8954 8 10 8.89543 10 10C10 10.5523 9.55228 11 9 11C8.44772 11 8 10.5523 8 10C8 7.79086 9.79086 6 12 6Z"
      />
    </g>
  ),
  bold: (
    <path
      d="M0.451695 14V0.985999H4.9427C5.7947 0.985999 6.5207 1.067 7.1207 1.229C7.7267 1.391 8.2217 1.622 8.6057 1.922C8.9957 2.222 9.2807 2.585 9.4607 3.011C9.6407 3.437 9.7307 3.917 9.7307 4.451C9.7307 4.757 9.6857 5.051 9.5957 5.333C9.5057 5.609 9.3647 5.87 9.1727 6.116C8.9867 6.356 8.7467 6.575 8.4527 6.773C8.1647 6.971 7.8197 7.139 7.4177 7.277C9.2057 7.679 10.0997 8.645 10.0997 10.175C10.0997 10.727 9.9947 11.237 9.7847 11.705C9.5747 12.173 9.2687 12.578 8.8667 12.92C8.4647 13.256 7.9697 13.52 7.3817 13.712C6.7937 13.904 6.1217 14 5.3657 14H0.451695ZM2.8727 8.294V12.11H5.3297C5.7797 12.11 6.1547 12.056 6.4547 11.948C6.7607 11.84 7.0037 11.696 7.1837 11.516C7.3697 11.336 7.5017 11.126 7.5797 10.886C7.6637 10.646 7.7057 10.391 7.7057 10.121C7.7057 9.839 7.6607 9.587 7.5707 9.365C7.4807 9.137 7.3397 8.945 7.1477 8.789C6.9557 8.627 6.7097 8.504 6.4097 8.42C6.1097 8.336 5.7467 8.294 5.3207 8.294H2.8727ZM2.8727 6.62H4.8077C5.6297 6.62 6.2537 6.47 6.6797 6.17C7.1057 5.87 7.3187 5.393 7.3187 4.739C7.3187 4.061 7.1267 3.578 6.7427 3.29C6.3587 3.002 5.7587 2.858 4.9427 2.858H2.8727V6.62Z"
      className="svg-fill"
    />
  ),
  italic: (
    <path
      d="M2.30417 13H0.612172L2.18717 0.102999H3.87917L2.30417 13Z"
      className="svg-fill"
    />
  ),
  underline: (
    <g fill="none">
      <path
        d="M7.00478 11.614C7.53878 11.614 8.01578 11.524 8.43578 11.344C8.85578 11.164 9.20978 10.912 9.49778 10.588C9.79178 10.264 10.0138 9.877 10.1638 9.427C10.3198 8.977 10.3978 8.482 10.3978 7.942V0.102999H12.1348V7.942C12.1348 8.686 12.0148 9.376 11.7748 10.012C11.5408 10.648 11.2018 11.2 10.7578 11.668C10.3198 12.13 9.78278 12.493 9.14678 12.757C8.51078 13.021 7.79678 13.153 7.00478 13.153C6.21278 13.153 5.49878 13.021 4.86278 12.757C4.22678 12.493 3.68678 12.13 3.24278 11.668C2.79878 11.2 2.45678 10.648 2.21678 10.012C1.98278 9.376 1.86578 8.686 1.86578 7.942V0.102999H3.60278V7.933C3.60278 8.473 3.67778 8.968 3.82778 9.418C3.98378 9.868 4.20578 10.255 4.49378 10.579C4.78778 10.903 5.14478 11.158 5.56478 11.344C5.99078 11.524 6.47078 11.614 7.00478 11.614Z"
        className="svg-fill"
      />
      <path
        d="M0.425781 14.8H13.5658V15.88H0.425781V14.8Z"
        className="svg-fill"
      />
    </g>
  ),
  heartOutline: (
    <g fill="none">
      <path
        className="svg-fill"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.272 4.9526C7.174 4.9526 6.077 5.3496 5.241 6.1446C4.441 6.9066 4 7.9176 4 8.9916C4 10.0646 4.441 11.0756 5.241 11.8376L12 18.2696L18.759 11.8376C19.559 11.0756 20 10.0646 20 8.9916C20 7.9186 19.559 6.9066 18.759 6.1446C17.088 4.5546 14.368 4.5546 12.697 6.1446L12 6.8086L11.303 6.1446C10.467 5.3496 9.37 4.9526 8.272 4.9526ZM12 20.9996L3.847 13.2406C2.656 12.1076 2 10.5986 2 8.9916C2 7.3846 2.656 5.8756 3.847 4.7416C6.067 2.6286 9.552 2.4386 12 4.1686C14.448 2.4386 17.933 2.6286 20.153 4.7416C21.344 5.8756 22 7.3846 22 8.9916C22 10.5986 21.344 12.1076 20.153 13.2406L12 20.9996Z"
      />
    </g>
  ),
};
/**
 * @deprecated
 *
 * DO NOT ADD NEW ICONS TO THIS FILE
 *
 * Any icons belonging to the Futuro design system should be added to the new
 * foundations directory, and follow naming conventions found in the CORE figma
 * shared/foundations/Icons/svg.tsx
 */
